"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.journeyDetails = void 0;
exports.journeyDetails = {
    idling: "Idling: ",
    time: "Time: ",
    distance: "Distance from start: ",
};
